export default "__VITE_ASSET__CXX02Weo__"